import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})

export class AuthGuardService {

  constructor(
      private _authService: AuthService,
      private _router: Router,
    ) { }

  canActivate(_next: ActivatedRouteSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> {
    if (this._authService.hasValidAccessToken()) {
      return true;
    }

    if (!this._authService.canRefreshToken()) {
      return this._router.createUrlTree(['/login']);
    }

    return this._authService.refreshAccessToken().pipe(
      map(() => true),
      catchError(() => {
        this._authService.clearSession();
        return of(this._router.createUrlTree(['/login']));
      })
    );
  }
  
}
